import React, {Component} from 'react';
import classNames from 'classnames';
import {checkIfDesktop} from '../../utils';


export default class CategoriesSidebar extends Component {
    constructor(props) {
        super(props);

        this.isMobile = !checkIfDesktop();

        this.state = {
            isCategorySelectOpen: false
        };

        this.toggleCategorySelect = this.toggleCategorySelect.bind(this);
        this.handleCategoryChange = this.handleCategoryChange.bind(this);
    }

    toggleCategorySelect() {
        this.setState((prevState) => ({isCategorySelectOpen: !prevState.isCategorySelectOpen}))
    }

    handleCategoryChange(e, category) {
        e.preventDefault();

        this.setState({isCategorySelectOpen: false});

        this.props.onCategoryChange(e, category);
    }

    renderCategories() {
        const categoriesList = this.props.subcategoriesList;

        let categories = categoriesList.map(category => (
            <li key={category.Term}>
                <a href="#"
                   title={category.Term}
                   onClick={(e) => this.handleCategoryChange(e, category.Term)}
                   className={classNames({'active': category.Term === this.props.activeCategory})}
                >
                    {category.Term} ({category.Count})
                </a>
            </li>
        ));

        if (categoriesList.length > 1) {
            const allProductsCount = categoriesList.reduce((total, item) => {
                total += item.Count;
                return total;
            }, 0);

            const mainCategory = (
                <li key={this.props.categoryId}>
                    <a href="#"
                       title="All"
                       onClick={(e) => this.handleCategoryChange(e, this.props.categoryId)}
                       className={classNames({'active': this.props.activeCategory === ''})}
                    >
                        All ({allProductsCount})
                    </a>
                </li>
            );

            categories = [mainCategory, ...categories];
        }

        return categories;
    }

    render() {
        const
            sidebarClasses = classNames(
                'searchFilter',
                'searchFilter--product-catalogue',
                {'open': this.state.isCategorySelectOpen}
            ),
            headingClasses = classNames(
                'boxHeading',
                {'boxHeading--no-dropdown': this.isMobile && this.props.subcategoriesList.length <= 1}
            );

        return (
            <section className={sidebarClasses} aria-controls="productsList">
                <h2 className={headingClasses}>
                    <span onClick={this.isMobile ? this.toggleCategorySelect : null}>
                        Categories
                    </span>
                </h2>
                <ul>
                    <a href="#productCatalogueSearchResults" className="skip">Skip to results</a>
                    {this.renderCategories()}
                </ul>
            </section>
        )
    }
}